"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";

const EventSlider = ({ awards }) => {
  const marqueeItems = [...awards, ...awards];
  const cardRefs = useRef([]);
  const [centerIndex, setCenterIndex] = useState(null);

  const detectCenterCard = () => {
    const centerX =
      window.innerWidth < 768
        ? window.innerWidth / 2
        : window.innerWidth / 2.4;

    let closestIndex = null;
    let closestDistance = Infinity;

    cardRefs.current.forEach((card, index) => {
      if (!card) return;

      const rect = card.getBoundingClientRect();
      const cardCenterX = rect.left + rect.width / 2;
      const distance = Math.abs(centerX - cardCenterX);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    setCenterIndex(closestIndex);
  };

  useEffect(() => {
    // Instead of constantly measuring each frame, run detection on scroll/resize
    // and schedule a single rAF measurement. This avoids continuous forced reflows.
    let scheduled = false;

    const scheduleDetect = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        detectCenterCard();
        scheduled = false;
      });
    };

    // initial run
    scheduleDetect();

    window.addEventListener("resize", scheduleDetect, { passive: true });
    const container = document;
    container.addEventListener("scroll", scheduleDetect, { passive: true });

    return () => {
      window.removeEventListener("resize", scheduleDetect);
      container.removeEventListener("scroll", scheduleDetect);
    };
  }, []);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] my-4 md:my-6">

        {/* Heading */}
        <div className="w-full sm:w-full md:w-[85%] lg:w-[80%] py-3 md:py-6 ">
          <h2 className="font-extrabold text-black text-[20px] sm:text-[22px] md:text-[26px] lg:text-[30px] xl:text-[42px] mb-2">
            Latest Updates
          </h2>
          <p className="text-black/70 text-[14px] sm:text-[15px] md:text-[17px]">
            This space highlights important developments, announcements and achievements that mark Medhavi Skills University’s 
            ongoing commitment to academic excellence and skill-driven education.
          </p>
        </div>

        {/* Slider */}
        <div
          className="flex gap-3 sm:gap-4 md:gap-5 marquee overflow-hidden"
          style={{ "--speed": "50s" }}
        >
          {marqueeItems.map((award, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              className={`
            relative overflow-hidden self-center transition-all duration-700

            min-w-[220px] h-[200px]
            sm:min-w-[260px] sm:h-[220px]
            md:min-w-[320px] md:h-[260px]

            ${centerIndex === index
                  ? "lg:min-w-[650px] lg:h-[400px]"
                  : "lg:min-w-[500px] lg:h-[300px]"
                }
          `}
            >
              {/* Image */}
              <Image
                src={award.img}
                alt={award.alt}
                fill
                className={`
              object-cover transition-transform duration-700
              ${centerIndex === index ? "scale-110" : "scale-100"}
            `}
              />

              {/* Gradient Overlay */}
              <div
                className={`absolute inset-0 z-10 transition-opacity duration-700 ${centerIndex === index ? "opacity-100" : "opacity-0"
                  }`}
                style={{
                  background:
                    "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)",
                }}
              />

              {/* Text */}
              <div
                className={`absolute bottom-3 md:bottom-4 lg:bottom-6 left-4 right-4 z-20
              text-white transition-opacity duration-700
              ${centerIndex === index ? "opacity-100" : "opacity-0"}
            `}
              >
                <p className="text-[14px] sm:text-[16px] md:text-[18px] leading-tight line-clamp-2">
                  {award.text}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>

  );
};

export default EventSlider;